import { ArrowsAltOutlined } from '@ant-design/icons';
import React from 'react';
import { MapRef } from 'react-map-gl';
import { useQueryString } from '../../../../hooks/use_query_string';
import { ExtendedMapQueryParams } from '../../../../routes/map_page/lib/map_page_types';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import styles from './modal_no_reports.less';

export const ModalNoReports = ({ mapRef, onClick }: { mapRef: MapRef; onClick: () => void }) => {
  const { replaceQueryString, getCurrentQuery } = useQueryString();
  const currentQuery = getCurrentQuery<ExtendedMapQueryParams>();
  const speciesQuery = currentQuery.species;
  const seasonGroupQuery = currentQuery.season_group;

  return (
    <>
      <li className={styles.noReportsBlurb}>
        <strong>For this map area we didn't find any Featured Fishing Reports.</strong>{' '}
        <OmniaButton
          size="md"
          kind="primary"
          onPress={() => {
            const currentZoom = mapRef.getZoom();
            mapRef.zoomTo(currentZoom - 3);
            onClick();
          }}
          className={styles.expandButton}
        >
          <ArrowsAltOutlined /> Expand Search Area
        </OmniaButton>
      </li>
      {(speciesQuery || seasonGroupQuery) && <strong>You could also try:</strong>}
      <ul className={styles.noOptionsList}>
        {speciesQuery && (
          <li>
            Removing your species filter by selecting{' '}
            <OmniaButton
              size="sm"
              kind="link"
              onPress={() => {
                replaceQueryString<ExtendedMapQueryParams>({
                  species: null,
                });
                onClick();
              }}
            >
              All Species
            </OmniaButton>
          </li>
        )}
        {seasonGroupQuery && (
          <li>
            Removing your season filter by selecting{' '}
            <OmniaButton
              size="sm"
              kind="link"
              onPress={() => {
                replaceQueryString<ExtendedMapQueryParams>({
                  season_group: null,
                });
                onClick();
              }}
            >
              All Seasons
            </OmniaButton>
          </li>
        )}
      </ul>
    </>
  );
};
